/**
 * Application Configuration
 * Static configuration values for the application.
 */

export const API_BASE_URL = 'https://api.windmill.fogstack.com';
//export const API_BASE_URL = 'http://localhost:8000';

// Google OAuth Client ID - update this with your Google OAuth client ID
// Get this from Google Cloud Console: https://console.cloud.google.com/
export const GOOGLE_CLIENT_ID = '614027598166-bkia7iso14pi7r685hmq3jt6a5ce7vq3.apps.googleusercontent.com';

// Webapp Base URL - used for extension authentication postMessage origin
// For local development: 'http://localhost:3000'
// For production: 'https://windmill.fogstack.com'
export const WEBAPP_BASE_URL = 'https://windmill.fogstack.com';
//export const WEBAPP_BASE_URL = 'http://localhost:3000'; // Uncomment for local development

